<template>
  <span>
    <home-hero></home-hero>
    <home-details></home-details>
    <home-services></home-services>
    <clients></clients>
  </span>
</template>

<script>
import HomeHero from '@/components/home/Hero'
import HomeDetails from '@/components/home/Details'
import HomeServices from '@/components/home/Services'
import Clients from '@/components/home/Clients'
export default {
  name: 'home',
  components: {
    HomeHero,
    HomeDetails,
    HomeServices,
    Clients
  }
}
</script>
